import { render, staticRenderFns } from "./RTVFormBox.vue?vue&type=template&id=2a67b8aa&scoped=true"
import script from "./RTVFormBox.vue?vue&type=script&lang=js"
export * from "./RTVFormBox.vue?vue&type=script&lang=js"
import style0 from "vue-search-select/dist/VueSearchSelect.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./RTVFormBox.vue?vue&type=style&index=2&id=2a67b8aa&prod&lang=css"
import style3 from "./RTVFormBox.vue?vue&type=style&index=3&id=2a67b8aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a67b8aa",
  null
  
)

export default component.exports